// extracted by mini-css-extract-plugin
module.exports = {"button":"AthleteClaimButton_button__V7woj"};